import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center pr-2" }
const _hoisted_2 = { class: "text-body-2 font-weight-medium text-wrap message-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    modelValue: _ctx.showLocal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showLocal) = $event)),
    timeout: _ctx.timeout,
    color: _ctx.color,
    location: "top right",
    variant: "flat",
    elevation: "4",
    rounded: "lg",
    class: "toast-notification"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_v_btn, {
        variant: "text",
        size: "small",
        density: "comfortable",
        "aria-label": "Close",
        class: "close-button",
        onClick: _ctx.closeSnackbar
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { size: "18" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("mdi-close", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          class: "mr-3 flex-shrink-0",
          size: "22"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.icon), 1)
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.message), 1)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "timeout", "color"]))
}